export default defineAppConfig({
  ui: {
    primary: 'heroblue',
    gray: 'stone',

    tooltip: {
      popper: {
        arrow: true
      },
      base: 'text-sm h-7 font-semibold',
      background: 'bg-charcoal-600 dark:bg-white',
      color: 'text-white dark:text-charcoal-600',
      ring: 'ring-0',
      arrow: {
        background: 'before:bg-charcoal-600 dark:before:bg-white',
        rounded: 'before:rounded-none',
        ring: 'before:ring-0'
      },
      default: {
        openDelay: 100,
        closeDelay: 50
      }
    },

    /*dropdown: {
      popper: {
        arrow: true
      },
      background: 'bg-charcoal-200 dark:bg-charcoal-800',
      divide: 'divide-charcoal-300/60',
      ring: 'dark:ring-charcoal-600',
      shadow: 'shadow-none dark:shadow-lg',
      rounded: 'rounded',
      width: 'min-w-56 w-auto max-w-64',
      item: {
        base: 'font-semibold transition-colors gap-2',
        padding: 'px-2 py-1',
        active: 'bg-white text-charcoal-700 dark:bg-black/70',
        inactive: 'text-charcoal-500/85',
        size: 'text-lg md:text-base',
        icon: {
          base: 'scale-90',
          active: 'text-charcoal-600 dark:text-white',
          inactive: 'text-charcoal-500/85 dark:text-white/75'
        }
      },
      arrow: {
        base: 'before:w-3 before:h-3',
        shadow: 'before:shadow-none',
        ring: 'before:ring-charcoal-200',
        background: 'before:bg-charcoal-200 dark:before:bg-charcoal-800',
      }
    },*/

    avatar: {
      placeholder: 'text-white',
      size: {
        '4xl': 'h-28 w-28 text-4xl',
        '5xl': 'h-36 w-36 text-4xl'
      }
    },

    input: {
      rounded: 'rounded-none',
      default: {
        size: 'md',
        loadingIcon: 'i-ri-loop-left-line'
      }
    },

    textarea: {
      rounded: 'rounded-none',
      default: {
        size: 'md'
      }
    },

    checkbox: {
      label: 'font-semibold'
    },

    formGroup: {
      label: {
        base: 'font-semibold text-base'
      }
    },

    button: {
      font: 'font-semibold',
      rounded: 'rounded',
      variant: {
        link: 'no-underline'
      },
      default: {
        loadingIcon: 'i-ri-loop-left-line'
      }
    },

    notification: {
      title: 'font-semibold text-lg leading-6 text-charcoal-950 dark:text-white',
      description: 'mt-1 text-base leading-5 text-charcoal-700 dark:text-gray-200',
      shadow: 'shadow-2xl',
      padding: 'p-5',
      icon: {
        base: 'flex-shrink-0 w-6 h-6'
      },
      transition: {
        enterActiveClass: 'transform ease-out duration-300 transition',
        enterFromClass: 'translate-y-6 opacity-0 sm:translate-y-0 sm:translate-x-10',
        enterToClass: 'translate-y-0 opacity-100 sm:translate-x-0',
        leaveActiveClass: 'transition ease-in duration-150',
        leaveFromClass: 'opacity-100',
        leaveToClass: 'opacity-0'
      }
    },

    notifications: {
      wrapper: 'fixed flex flex-col justify-end z-[55]',
      position: 'bottom-0 end-0',
      width: 'w-full sm:w-[28rem]',
      container: 'px-4 sm:px-6 py-4 space-y-4 overflow-y-auto'
    },

    configMenu: {
      default: {
        showCreateOptionWhen: 'always'
      }
    },

    alert: {
      padding: 'p-3',
      rounded: 'rounded',
      title: 'font-semibold text-base',
      description: 'mt-0 text-base leading-snug opacity-100',
      default: {
        variant: 'soft'
      },
      icon: {
        base: 'w-7 h-7'
      }
    },

    selectMenu: {
      rounded: 'rounded-none',
      default: {
        selectedIcon: 'i-ri-check-line'
      },
      option: {
        active: 'bg-ice-200',
        selectedIcon: {
          base: 'text-sage-800'
        }
      },
      popper: {
        arrow: true
      }
    },

    select: {
      rounded: 'rounded',
      default: {
        loadingIcon: 'i-ri-loop-left-line',
        trailingIcon: 'i-ri-arrow-down-s-line'
      }
    },

    accordion: {
      default: {
        openIcon: 'i-ri-arrow-down-s-line'
      }
    },

    badge: {
      default: {
        variant: 'subtle'
      },
      rounded: 'rounded'
    },

    popover: {
      overlay: {
        background: 'bg-black/50'
      }
    },

    slideover: {
      overlay: {
        background: 'bg-black/50'
      }
    },

    tabs: {
      wrapper: 'f-tabs relative space-y-6 flex flex-col items-center',
      base: 'transition-opacity duration-200 ease-in-out',
      container: 'relative w-full',
      list: {
        background: 'bg-white dark:bg-charcoal-800',
        rounded: 'rounded-full',
        shadow: 'border border-gray-200',
        padding: 'p-1',
        height: 'h-12 sm:h-14',
        width: 'w-full max-w-lg mx-auto',
        tab: {
          active: 'text-heroblue-900 dark:text-white',
          inactive: 'text-charcoal-500 hover:bg-charcoal-100 dark:text-gray-300 dark:hover:bg-charcoal-700',
          height: 'h-full',
          padding: 'px-2',
          size: 'text-sm sm:text-base',
          font: 'font-semibold',
          rounded: 'rounded-full'
        },
        marker: {
          background: 'bg-ice-50 dark:bg-charcoal-900',
          rounded: 'rounded-full',
          shadow: 'border border-heroblue'
        }
      }
    }
  }
});
